import {
    NEW_MATCH_LOCAL,
    JOIN_GAME_LOCAL,
    ADD_TO_ROSTER_SOCKET,
    ADD_TO_ROSTER_LOCAL,
    UPDATE_TEE_SCORE_SOCKET,
    UPDATE_TEE_SCORE_LOCAL,
    LEAVE_GAME_LOCAL,
    RESET_MATCH_STATE} from '../actions/matchManagement';

const initState = {
    gameroom: '',
    location: '',
    roster: {}
};

export const matchMngtReducer = (state = initState, action) =>{
    switch(action.type){
        case NEW_MATCH_LOCAL:
            return {
                ...state,
                gameroom: action.gameroom,
                location: action.location
            };

        case JOIN_GAME_LOCAL:
            console.log('JOIN GAME LOCAL');
            return {
                ...state,
                gameroom: action.gameroom
            };

        case ADD_TO_ROSTER_SOCKET:
            let rosterPayload = {
                gameroom: action.gameroom,
                gamertag: action.gamertag
            };

            action.socket.emit('update-roster', rosterPayload);

            return state;

        case ADD_TO_ROSTER_LOCAL:
            if(action.user === ''){
                return state;
            }
            else{
                return {
                    ...state,
                    roster: {
                        ...state.roster,
                        ...action.roster
                    }
                }
            }

        case UPDATE_TEE_SCORE_SOCKET:
            // Payload Deconstruct & Prep Work
            const { gameroom, gamertag, tee, score } = action;
            const teeParsed = parseInt(tee, 10);
            const scoreParsed = parseInt(score, 10);

            console.log(`Tee Socket: ${gameroom}, Gamertag: ${gamertag}, Tee: ${tee}, Score: ${score}`);

            let scoreArray = [...state.roster[gamertag]];
            scoreArray[teeParsed-1] = scoreParsed;

            let payload = {
                gameroom,
                gamertag,
                score: scoreArray
            };
            action.socket.emit('score-update', payload);
            return state;

        case UPDATE_TEE_SCORE_LOCAL:
            return {
              ...state,
              roster: {
                ...state.roster,
                [action.gamertag]: action.scoreArray
              }
            };

        case LEAVE_GAME_LOCAL:
            return {
                ...state,
                gameroom: '',
                location: '',
                roster: {}
            };

        case RESET_MATCH_STATE:
            console.log(RESET_MATCH_STATE);
            return {
                ...state,
                gameroom: '',
                location: '',
                roster: {}
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/matchManagement.js